import React from 'react';
import PropTypes from 'prop-types';

export const MaintenancePage = ({ brand }) => {
    const brandsMap = {
      ngn: 'The Sun',
      tls: 'The TLS',
      tls_com: 'The TLS',
      tnl: 'The Times',
      tnl_com: 'The Times',
      wls: 'Wireless'
    };
    const brandsWebsitesMap = {
      ngn: 'https://www.thesun.co.uk/',
      tls: 'https://www.the-tls.co.uk/',
      tls_com: 'https://www.the-tls.com/',
      tnl: 'https://www.thetimes.co.uk/',
      tnl_com: 'https://www.thetimes.com/',
      wls: ['https://virginradio.co.uk/', 'https://talksport.com/']
    };

    return (
      <React.Fragment>
        {/* This is component for one time usage only, ignore the inline styling */}
        <article style={{
            display: 'block',
            textAlign: 'left',
            width: '650px',
            margin: '0 auto',
            padding: '120px 160px'
        }}
        >
          <h1>We&rsquo;ll be back soon!</h1>
          <div>
            <p>Sorry for the inconvenience. We&rsquo;re performing some maintenance at the moment.</p>
            <p>&mdash; {brandsMap[brand]} Team</p>
            {brand !== 'wls' ?
              <p>The <a href={brandsWebsitesMap[brand]}>website</a> is still up and running.</p> :
              /* This is component for one time usage only, ignore the way we get the data */
              <p>The <a href={brandsWebsitesMap[brand][0]}>Virgin Radio</a> and <a href={brandsWebsitesMap[brand][1]}>talkSPORT</a> websites are still up and running.</p>
            }
          </div>
        </article>
      </React.Fragment>
    );
};

MaintenancePage.propTypes = {
  brand: PropTypes.string.isRequired
};
